import type { ServerEvent } from '@/types/ServerEvent';
import { EventV2 } from '@/services/EventService/abstract/EventV2';

export default class ServerSideChangedUserStatusEvent extends EventV2<ServerEvent> {}
